import CryptoJS from "crypto-js";
 
const decryptArrayUserPermissions = (encryptedPermissions) => {
  const decrypted = CryptoJS.AES.decrypt(
    encryptedPermissions,
    process.env.REACT_APP_SECRET_KEY_ENCRYPT_PERMISSIONS
  );
  return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
};

export default {
  decryptArrayUserPermissions,
};
